import { render } from "./question-result-drag-drop-card.vue?vue&type=template&id=6e4f31d3&ts=true"
import script from "./question-result-drag-drop-card.vue?vue&type=script&lang=ts"
export * from "./question-result-drag-drop-card.vue?vue&type=script&lang=ts"

import "./question-result-drag-drop-card.vue?vue&type=style&index=0&id=6e4f31d3&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__